import PublicHeader from '@/components/PublicHeader'
import PublicFooter from '@/components/PublicFooter'

interface CreditPackage {
  credits: number;
  price: number;
}

const creditPackages: CreditPackage[] = [
  { credits: 100, price: 2 },
  { credits: 250, price: 4 },
  { credits: 500, price: 7 },
  { credits: 1000, price: 12 },
  { credits: 2500, price: 25 },
  { credits: 5000, price: 45 },
];

export default function ShopifyPricingPage() {
  const handlePurchase = (pkg: CreditPackage) => {
    // Redirect to Shopify App Store listing
    const shopifyAppStoreUrl = import.meta.env.VITE_SHOPIFY_APP_STORE_URL || 'https://apps.shopify.com/search?q=gistmag%20alt%20generator';
    window.open(shopifyAppStoreUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex flex-col">
      <PublicHeader hideMakeAndDashboard={true} />
      
      <div className="flex-1 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Custom Header with Shopify Icon */}
          <div className="mb-8 text-center">
            <div className="flex items-center justify-center mb-6">
              <img
                src="/icon128.png"
                alt="GistMag Alt Text Generator"
                className="w-16 h-16 mr-4"
              />
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                GistMag Alt Text Generator
              </h1>
            </div>
          </div>

          {/* Main Content */}
          <div className="text-center mb-8">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Pricing & Credits
          </h2>
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            Purchase Credits
          </h3>
            <p className="text-gray-700 dark:text-gray-300">
              Purchase credits to generate alt text for your product images. Credits never expire.
            </p>
          </div>

          {/* Credit Packages Card */}
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
          {/* First Row - 5 packages */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-6">
            {creditPackages.slice(0, 5).map((pkg, index) => (
              <div
                key={index}
                className="bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 p-6 flex flex-col"
              >
                <h4 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                  {pkg.credits.toLocaleString()} Credits
                </h4>
                <div className="mb-6 flex-grow">
                  <p className="text-3xl font-bold text-green-600 dark:text-green-400">
                    ${pkg.price}
                  </p>
                </div>
                <button
                  onClick={() => handlePurchase(pkg)}
                  className="w-full px-4 py-3 bg-gray-200 dark:bg-gray-600 text-gray-900 dark:text-white rounded-lg hover:bg-gray-300 dark:hover:bg-gray-500 transition font-medium"
                >
                  Purchase
                </button>
              </div>
            ))}
          </div>
          {/* Second Row - 1 package (centered) */}
          <div className="flex justify-center">
            <div className="w-full max-w-xs">
              {creditPackages.slice(5).map((pkg, index) => (
                <div
                  key={index}
                  className="bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 p-6 flex flex-col"
                >
                  <h4 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                    {pkg.credits.toLocaleString()} Credits
                  </h4>
                  <div className="mb-6 flex-grow">
                    <p className="text-3xl font-bold text-green-600 dark:text-green-400">
                      ${pkg.price}
                    </p>
                  </div>
                  <button
                    onClick={() => handlePurchase(pkg)}
                    className="w-full px-4 py-3 bg-gray-200 dark:bg-gray-600 text-gray-900 dark:text-white rounded-lg hover:bg-gray-300 dark:hover:bg-gray-500 transition font-medium"
                  >
                    Purchase
                  </button>
                </div>
              ))}
            </div>
          </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 text-center text-gray-600 dark:text-gray-400">
            <p className="text-sm">
              All credit purchases are processed securely through Shopify. Credits are added to your account immediately after purchase.
            </p>
          </div>
        </div>
      </div>
      
      <PublicFooter />
    </div>
  );
}

